(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
class MobileStickyHeader extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.ticking = false;
    this.state = null;
    this.preventReveal = false;
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-mobile-header');
    if (!this.header) return;

    this.headerSection = this.header.querySelector('.mobile-header');
    this.headerHeight = this.headerSection.offsetHeight;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.updateHeaderHeight.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    window.addEventListener('resize', this.onResizeHandler, { passive: true });
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);
  }

  updateHeaderHeight() {
    this.headerHeight = this.headerSection.offsetHeight;
  }

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;

    requestAnimationFrame(() => {
      if (this.predictiveSearch?.isOpen) {
        this.ticking = false;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollingDown = scrollTop > this.lastScrollTop;
      const pastHeader = scrollTop > this.headerHeight;

      let nextState = 'reset';

      if (pastHeader && scrollingDown) {
        nextState = 'hide';
      } else if (pastHeader && !scrollingDown) {
        nextState = this.preventReveal ? 'hide' : 'reveal';
      }

      if (nextState !== this.state) {
        this.state = nextState;
        this.applyState(nextState);
      }

      if (this.preventReveal && !scrollingDown) {
        clearTimeout(this.revealTimeout);
        this.revealTimeout = setTimeout(() => {
          this.preventReveal = false;
        }, 80);
      }

      this.lastScrollTop = scrollTop;
      this.ticking = false;
    });
  }

  applyState(state) {
    switch (state) {
      case 'hide':
        this.header.classList.add(
          'shopify-section-mobile-header-hidden',
          'shopify-section-mobile-header-sticky'
        );
        this.header.classList.remove('animate');
        break;

      case 'reveal':
        this.header.classList.add(
          'shopify-section-mobile-header-sticky',
          'animate'
        );
        this.header.classList.remove('shopify-section-mobile-header-hidden');
        break;

      default:
        this.header.classList.remove(
          'shopify-section-mobile-header-hidden',
          'shopify-section-mobile-header-sticky',
          'animate'
        );
    }
  }
}

customElements.define('mobile-sticky-header', MobileStickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
class StickySecondaryHeader extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.ticking = false;
    this.state = null;
    this.preventReveal = false;
  }

  connectedCallback() {
    this.header = document.querySelector('.shopify-section-header');
    if (!this.header) return;

    this.headerHeight = this.header.offsetHeight;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.updateHeaderHeight.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    window.addEventListener('resize', this.onResizeHandler, { passive: true });
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);
  }

  updateHeaderHeight() {
    this.headerHeight = this.header.offsetHeight;
  }

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;

    requestAnimationFrame(() => {
      if (this.predictiveSearch?.isOpen) {
        this.ticking = false;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollingDown = scrollTop > this.lastScrollTop;
      const pastHeader = scrollTop > this.headerHeight;

      let nextState = 'reset';

      if (pastHeader && scrollingDown) {
        nextState = 'hide';
      } else if (pastHeader && !scrollingDown) {
        nextState = this.preventReveal ? 'hide' : 'reveal';
      }

      if (nextState !== this.state) {
        this.state = nextState;
        this.applyState(nextState);
      }

      if (this.preventReveal && !scrollingDown) {
        clearTimeout(this.revealTimeout);
        this.revealTimeout = setTimeout(() => {
          this.preventReveal = false;
        }, 80);
      }

      this.lastScrollTop = scrollTop;
      this.ticking = false;
    });
  }

  applyState(state) {
    switch (state) {
      case 'hide':
        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );
        this.header.classList.remove('animate');
        break;

      case 'reveal':
        this.header.classList.add(
          'shopify-section-header-sticky',
          'animate'
        );
        this.header.classList.remove('shopify-section-header-hidden');
        break;

      default:
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
    }
  }
}

customElements.define('sticky-secondary-header', StickySecondaryHeader);


  } catch(e) { console.error(e); }
})();
})();
